import type { UnitSystem } from '@onestep/camel-api';
import { find, includes } from 'lodash';
import { useEffect, useRef } from 'react';
import { Cookies } from 'react-cookie';

import { measurementType, unitsMapping } from './MeasurementEnums';
import { cmToFt, cmToIn, unitsOptions } from './MeasurementOptions';

const cookies = new Cookies();
const cookieName = 'unit';

export const convert = (
  value: number,
  type: measurementType,
  cookie: unitsMapping,
  value1?: number,
) => {
  const item = find(unitsOptions, (x) => includes(unitsMapping[cookie], x.unit) && x.type === type);
  return Number(item?.convert(value, value1 || 0));
};

export const setCookie = (unit: unitsMapping) => cookies.set(cookieName, unit);

export const getCookie = () => cookies.get(cookieName) || unitsMapping['kg/cm'];

export const removeCookie = () => cookies.remove(cookieName, { path: '/' });

export const isPoundInchType = (unitMapping: unitsMapping) =>
  Number(unitMapping) === Number(unitsMapping['lb/ftin']);

export const isKgCmType = (unitMapping: unitsMapping) =>
  Number(unitMapping) === Number(unitsMapping['kg/cm']);

export const CheckIfFirstRender = () => {
  const isMountRef = useRef(true);
  useEffect(() => {
    isMountRef.current = false;
  }, []);
  return isMountRef.current;
};

export const isToCovertValues = (
  isMount: boolean,
  unitMapping: unitsMapping,
  measureType: measurementType,
) => {
  return (
    ((isMount && !isKgCmType(unitMapping)) || !isMount) && measureType !== measurementType.inch
  );
};

export const convertMeasurementValue = (value: number) => {
  const ftValue = cmToFt(value);
  const inchValue = cmToIn(value, 1);
  if (ftValue > 0) return `${ftValue} ft, ${inchValue} in`;
  return `${inchValue} in`;
};

export const getUnitType = (unitsMapping: unitsMapping): UnitSystem =>
  isPoundInchType(unitsMapping) ? 'imperial' : 'metric';
